const pmbk = {
    checklist: {
        icon: 'check-square',
        text: 'Checklist',
        route: 'checklist',
        children: {
            file: {
                icon: null,
                text: 'File Resume',
                route: 'admin.classical.files.resume',
                role: {
                    classical: [ 'admin', 'project-manager' ],
                }
            },
            validasi: {
                icon: null,
                text: 'Validasi Ujian',
                route: 'admin.classical.exam.validation',
                role: {
                    classical: [ 'admin', 'project-manager' ],
                }
            },
            absensi: {
                icon: null,
                text: 'Absensi & Observasi',
                route: 'admin.classical.class.observation',
                role: {
                    classical: [ 'project-manager' ],
                }
            },
            published: {
                icon: null,
                text: 'Validasi Remedi',
                route: 'admin.classical.remid.validation',
                role: {
                    classical: [ 'project-manager' ],
                }
            },
        },
        role: {
            classical: [ 'admin', 'project-manager' ],
        }
    },
}

export default pmbk
